import * as React from 'react';
import { cloneElement } from 'react';

import { get } from 'lodash';
import {
  ExportButton,
  sanitizeListRestProps,
  TopToolbar,
  useGetOne,
} from 'react-admin';

import RequestButton from './buttons/RequestButton';

const Actions = ({ isAdmin, ...props }) => {
	const { className, filters, resource, basePath, ...rest } = props;
	const { data: userProfile, loading } = useGetOne("users", "profile");
	if (loading) {
		return null;
	}
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{cloneElement(filters, { context: "button" })}
			{/* {isAdmin && <CreateButton resource={resource} basePath={basePath} />} */}
			{isAdmin && <ExportButton resource={resource} basePath={basePath} />}
			{!isAdmin && !get(userProfile, "profile.can_request_wtr") && (
				<RequestButton resource={resource} basePath={basePath} />
			)}
		</TopToolbar>
	);
};

export default Actions;
